// src/services/workflowService.js
import { api } from './api';
import { createService } from './factory';

// Create the workflow template service using the factory
const workflowTemplateServiceBase = createService('WorkflowTemplate', '/workflows/templates');

// Create the workflow instance service using the factory
const workflowInstanceServiceBase = createService('WorkflowInstance', '/workflows/instances', {
  customEndpoints: {
    // Workflow actions
    advanceWorkflow: async (id, data = {}) => {
      return api.post(`/workflows/instances/${id}/advance`, data);
    },
    
    rejectWorkflow: async (id, data = {}) => {
      return api.post(`/workflows/instances/${id}/reject`, data);
    },
    
    skipWorkflowStep: async (id, data = {}) => {
      return api.post(`/workflows/instances/${id}/skip`, data);
    },
    
    cancelWorkflow: async (id, data = {}) => {
      return api.post(`/workflows/instances/${id}/cancel`, data);
    },
    
    restartWorkflow: async (id, data = {}) => {
      return api.post(`/workflows/instances/${id}/restart`, data);
    },
    
    // User-specific endpoints
    getMyPendingWorkflows: async () => {
      return api.get('/workflows/my-pending');
    },
    
    // Client-specific endpoints
    getClientWorkflows: async (clientId) => {
      return api.get(`/workflows/client/${clientId}`);
    }
  }
});

// Create backwards-compatible exports for workflow templates
export const getWorkflowTemplates = async (params = {}) => {
  return workflowTemplateServiceBase.getAll(params);
};

export const getWorkflowTemplateById = async (id) => {
  return workflowTemplateServiceBase.getById(id);
};

export const createWorkflowTemplate = async (data) => {
  return workflowTemplateServiceBase.create(data);
};

export const updateWorkflowTemplate = async (id, data) => {
  return workflowTemplateServiceBase.update(id, data);
};

export const deleteWorkflowTemplate = async (id) => {
  return workflowTemplateServiceBase.delete(id);
};

// Create backwards-compatible exports for workflow instances
export const getWorkflowInstances = async (params = {}) => {
  return workflowInstanceServiceBase.getAll(params);
};

export const getWorkflowInstanceById = async (id) => {
  return workflowInstanceServiceBase.getById(id);
};

export const createWorkflowInstance = async (data) => {
  return workflowInstanceServiceBase.create(data);
};

// Export workflow actions
export const advanceWorkflow = async (id, data = {}) => {
  return workflowInstanceServiceBase.advanceWorkflow(id, data);
};

export const rejectWorkflow = async (id, data = {}) => {
  return workflowInstanceServiceBase.rejectWorkflow(id, data);
};

export const skipWorkflowStep = async (id, data = {}) => {
  return workflowInstanceServiceBase.skipWorkflowStep(id, data);
};

export const cancelWorkflow = async (id, data = {}) => {
  return workflowInstanceServiceBase.cancelWorkflow(id, data);
};

export const restartWorkflow = async (id, data = {}) => {
  return workflowInstanceServiceBase.restartWorkflow(id, data);
};

// Export user-specific endpoints
export const getMyPendingWorkflows = async () => {
  return workflowInstanceServiceBase.getMyPendingWorkflows();
};

// Export client-specific endpoints
export const getClientWorkflows = async (clientId) => {
  return workflowInstanceServiceBase.getClientWorkflows(clientId);
};